export default __webpack_public_path__ + "static/media/no-result.7512474e.svg";